import classNames from "classnames";
import styles from "./YellowHeaderWrapper.module.scss";

const YellowHeaderWrapper = ({ title, bordered = true, children }) => {
  return (
    <div className="mt-3">
      <div className={styles["heading"]}>{title}</div>
      <div className={`p-${bordered ? "2" : "0"} bg-white`}>
        <div
          className={classNames({
            [styles["wrapper"]]: bordered,
            [styles["wrapper-without-borders"]]: !bordered,
          })}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default YellowHeaderWrapper;